import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import _, { filter } from "lodash";
import OrderCourseCard from "./OrderCourseCard";
import OrderPlacedToastMessage from "./OrderPlacedToastMessage";
import { orderPlacedClear } from "../../redux/checkout/actions";
import moment from "moment";
import { Link } from "react-router-dom";
import Pagination from "../../pages/Orders/Pagination";
import PaginationMyOrders from "./PaginationMyOrders";
import Loader from "../Loader/Loader";
import ProductCardComponent from "../NewDesign/ProductCard/ProductCardComponent";
import {
  ProductCardPriceInfo,
  convertTimeFormat,
  convertTimeInHourAndMin,
  getProcureInfo,
  getSessionType,
  redirectToPageUtil,
} from "../../utils/AppUtils";
import useLogin from "../../custom-hooks/useLogin";
import "./OrderHistorySection.scss";
import { format } from "crypto-js";
import { useNavigate } from "react-router-dom";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import CONFIG from "../../utils/config";
import { getAssignCourseClear } from "../../redux/courses/actions";
import NotFoundComponent from "../NewDesign/NotFound/NotFoundComponent";
import { render } from "@testing-library/react";
let PageSize = 10;
const OrderHistorySectionCopy = (props) => {
  const {
    ordersData,
    ordersDataFinal,
    isLoading,
    paginateCB,
    setIsLoading,
    pageNum,
    setHasNoMore,
    totalrecords,
    isFetching,
    setIsFetching,
    filterWithYear,
    setPageNum,
    setsearchedOrNot,
    searchedOrNot,
  } = props;
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {};
  }, []);

  const search = window.location.search;
  const params = new URLSearchParams(search);

  // useEffect(() => {
  //   console.log("totalrecords--", totalrecords);
  //   const count = ordersData.filter((item) => item.list.length > 0).length;
  //   setTotalCount(count);
  // }, [totalrecords]);

  const [orderDataArray, setOrderDataArray] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [searchText, setSearchText] = useState("");

  // const currentTableData = useMemo(() => {
  //   console.log("ordersdatarray", orderDataArray);
  //   return orderDataArray;
  // }, [orderDataArray]);

  // useEffect(() => {
  //   console.log("current_table", currentTableData);
  //   return () => {};
  // }, [currentTableData]);

  useEffect(() => {
    setOrderDataFunc(_.reverse(_.sortBy(ordersData, "order_created.date")));
  }, [ordersData]);

  const [allListEmpty, setAllListEmpty] = useState(true);
  const setOrderDataFunc = (ordersDataVar, isSearched = false) => {
    // setOrderDataArray([]);
    console.log("orders---", ordersDataVar);
    if (ordersDataVar.length > 0) {
      let count = 0;
      for (let i of ordersDataVar) {
        let list = i.list;
        i.noProduct = false;
        if (i.list.length === 0) {
          i.noProduct = true;
        } else {
          count += 1;
          setAllListEmpty(false);
        }
        console.log("formatted---list", list);

        let orderArray = [];
        for (let listItem of list) {
          if (listItem?.product_type === "course") {
            if (i?.list) {
              let courseList = [];
              courseList.push(listItem);
              orderArray.push(formatProductCardData(courseList)[0]);
              // i.cardData = formatProductCardData(i.list);
              console.log("type-", typeof i.cardData, i.cardData);
            }
          } else if (listItem?.product_type === "video") {
            if (i?.list) {
              let videoList = [];
              videoList.push(listItem);
              orderArray.push(formatVideoDataForProductCard(videoList)[0]);
              // i.cardData = formatVideoDataForProductCard(videoList);
              console.log("type-123", typeof i.cardData, i.cardData, i.list);
            }
          } else if (
            listItem?.product_type === "bundle" ||
            listItem?.product_type === "learningpath"
          ) {
            let bundle = [];
            bundle.push(listItem);
            if (bundle) {
              orderArray.push(formatCartData(bundle)[0]);
            }
            // i.cardData = formatCartData(bundle);
          } else if (listItem?.product_type === "coaching") {
            let coachingData = [];
            coachingData.push(listItem);
            orderArray.push(formatCoachingCard(coachingData)[0]);
          } else if (listItem?.product_type === "event") {
            let eventData = [];
            eventData.push(listItem);
            orderArray.push(formatEventCardData(eventData)[0]);
          } else if (listItem?.product_type === "roleplay") {
            let rpData = [];
            rpData.push(listItem);
            orderArray.push(formatProductCardData(rpData)[0]);
          }
          console.log("ordersarray--", orderArray);
          i.cardData = orderArray;
        }
      }
      // setTotalCount(count);
      // let newProdArr = ordersDataVar;
      setOrderDataArray(ordersDataVar);
      console.log("check1-4", ordersDataVar);
      // if (pageNum > 1 && !isSearched) {
      //   newProdArr = [...orderDataArray, ...ordersDataVar];
      //   console.log("orders data new prod arr", newProdArr);
      //   console.log(newProdArr);
      //   setOrderDataArray(newProdArr);
      // } else {
      //   console.log("orders_data", ordersDataVar);
      //   setOrderDataArray(ordersDataVar);
      // }

      setIsLoading(false);
      setIsFetching(false);
      // console.log("recordsLength: ", ordersDataFinal.length, newProdArr.length);
      // if (!isSearched) {
      //   if (ordersDataFinal?.length === newProdArr.length) {
      //     setIsLoading(false);
      //     setHasNoMore(true);
      //   } else {
      //     setHasNoMore(false);
      //   }
      // }
    } else {
      // setIsLoading(false);
      // setIsFetching(false);
      setOrderDataArray([]);
    }
  };

  useEffect(() => {
    const count = orderDataArray.filter((item) => item.list?.length > 0).length;
    setTotalCount(count);
  }, [orderDataArray]);

  const makeSearch = (noData = false) => {
    console.log("order final data", ordersDataFinal, searchText, noData);
    // setPageNum(1);
    setOrderDataArray([]);
    if (noData && !_.isEmpty(ordersDataFinal)) {
      console.log("order final data2", ordersDataFinal);
      let searched_orders_data = [];
      let orders_data = _.clone(ordersDataFinal);
      for (let item of orders_data) {
        if (!_.isEmpty(item?.list)) {
          searched_orders_data.push(item);
        }
      }
      setOrderDataFunc(searched_orders_data, true);
      setTotalCount(searched_orders_data.length);
    } else {
      let searched_orders_data = [];
      let orders_data = _.clone(ordersDataFinal);
      for (let item of orders_data) {
        if (item?.list) {
          for (let list_item of item?.list) {
            if (_.toLower(list_item.name).includes(_.toLower(searchText))) {
              const orderExists = searched_orders_data.some(
                (order) => order.orderId === item?.orderId
              );
              if (!orderExists) {
                searched_orders_data.push(item);
              }
            }
          }
        }
      }
      console.log("searched_data", searched_orders_data);
      setOrderDataFunc(searched_orders_data, true);
      setTotalCount(searched_orders_data.length);
    }
  };

  const formatEventCardData = (eventData) => {
    let prodArray = [];
    for (let item of eventData) {
      let tags = [];
      let logoURL = "";
      let btnTitle = "Explore";
      logoURL = item?.provider?.provider_img;

      if (item?.provider?.provider_display_name) {
        tags.push(item?.provider?.provider_display_name);
      }
      tags.push("Session");
      if (item?.session_delivery_mode) {
        let deliveryMode = getSessionType(item?.session_delivery_mode);
        tags.push(deliveryMode);
      }
      if (item?.session_host) {
        tags.push(item?.session_host);
      }

      let priceInfo = getProcureInfo(item?.purchased_info);
      let footerComp = "";
      let productPrice = "";
      if (item?.product_price) {
        productPrice = `Price: $${item?.product_price}`;
      }
      prodArray.push({
        id: item?.product_id,
        is_like: item?.is_like ? item?.is_like : false,
        is_bookmark: item?.is_bookmark ? item?.is_bookmark : false,
        dbId: item?.list_id,
        productType: item?.service_type,
        productOrigin: item?.source,
        title: item?.name,
        logoURL: logoURL,
        logoAltText: "VD",
        bannerURL: item?.thumbnail,
        tagsArray: tags,
        description: item?.description ? item?.description : "",
        duration: convertTimeInHourAndMin(item?.duration ? item?.duration : 0),
        showHeader: true,
        showPlayButton: false,
        showProviderIcon: true,
        showLikeMenu: true,
        showProgress: false,
        showBody: false,
        showFooter: true,
        btnTitle: btnTitle,
        footerLineComp: productPrice
          ? ProductCardPriceInfo(productPrice, "green")
          : "",
        btnAction: () => navigateToSessionView(item),
        descAction: () => {},
        bannerAction: (e) => navigateToSessionView(item),
        cardClassName: "",
        isLoading: false,
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
        priceInfo,
      });
    }
    return prodArray;
  };

  const navigateToSessionView = (data) => {
    let paramsReq = {
      event_id: data.event_id,
      event_code: data?.event_code,
      source: data.source,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);

    let url = `/event-detail?c=${encodedUrl}`;
    // url = url + `&event_code=${data?.event_code}` + `&source=${data.source}`;
    navigate(url);
  };

  const formatCoachingCard = (coachingData) => {
    console.log("coachingData", coachingData);
    let eventArr = [];
    for (let item of coachingData) {
      let tags = [];
      let logoURL = "";
      let btnTitle = "Explore";
      logoURL = item?.provider?.provider_img;

      tags.push(item?.provider?.provider_display_name);
      tags.push("Services");
      tags.push(
        _.toLower(item?.payment_frequency) === "monthly"
          ? "Subscription"
          : "One Time"
      );

      let priceInfo = getProcureInfo(item?.purchased_info);
      let footerComp = "";
      let productPrice = "";
      if (item?.product_price) {
        productPrice = `Price: $${item?.product_price}`;
      }
      eventArr.push({
        id: item?.product_id,
        is_like: item?.is_like ? item?.is_like : false,
        is_bookmark: item?.is_bookmark ? item?.is_bookmark : false,
        dbId: item?.list_id,
        productType: item?.service_type,
        productOrigin: item?.source,
        title: item?.name,
        logoURL: logoURL,
        logoAltText: "VD",
        bannerURL: item?.thumbnail,
        tagsArray: tags,
        description: item?.description ? item?.description : "",
        is_coaching: true,
        show_subscription:
          _.toLower(item?.payment_frequency) === "monthly" ? true : false,
        duration: convertTimeInHourAndMin(item?.duration ? item?.duration : 0),
        showHeader: true,
        showPlayButton: false,
        showProviderIcon: true,
        showLikeMenu: true,
        showProgress: false,
        showBody: false,
        showFooter: true,
        btnTitle: btnTitle,
        footerLineComp: productPrice
          ? ProductCardPriceInfo(productPrice, "green")
          : "",
        btnAction: () => navigateToCoachingView(item),
        descAction: () => {},
        bannerAction: (e) => navigateToCoachingView(item),
        cardClassName: "",
        isLoading: false,
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
        priceInfo,
      });
    }
    console.log("event array", eventArr);
    return eventArr;
  };

  const navigateToCoachingView = (data) => {
    let paramsReq = {
      service_code: data?.service_code,
      service_id: data?.product_id,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    let url = `/coaching-detail?c=${encodedUrl}`;
    navigate(url);
  };

  const navigateToView = (video) => {
    console.log("video--", video);

    let paramsReq = {
      code: video?.course_code,
      source: video?.source,
      is_paid: video?.priceInfo.isFree,
    };
    if (!_.isEmpty(video.categoryId)) {
      paramsReq.catId = video?.categoryId[0];
    }
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    let url = `/video-view-page/${video?.product_id}/?c=${encodedUrl}`;
    navigate(url);
  };

  let navigate = useNavigate();

  // const { isLoggedIn } = useLogin();
  const [courseData, setCourseData] = useState({});
  const [ordersCount, setOrdersCount] = useState();
  const authBroker = useSelector((state) => state.auth.authBroker);

  const formatProductCardData = (course_data) => {
    console.log("course----", course_data[0], typeof course_data, course_data);

    // course_data = course_data[0];
    let prodArr = [];
    console.log("type-1", typeof prodArr);
    for (let course of course_data) {
      let tags = [];
      let btnTitle = "Explore";
      if (course?.provider?.provider_display_name) {
        tags.push(course.provider.provider_display_name);
      }
      if (course?.product_type === "roleplay") {
        tags.push("Role play");
      } else {
        tags.push("Course");
      }
      if (course?.lessons) {
        tags.push(`${course.lessons} Module${course.lessons > 1 ? "s" : ""}`);
      }

      if (course?.duration) {
        tags.push(convertTimeFormat(course.duration, true));
      }
      let priceInfo = "";
      if (course?.purchased_info) {
        priceInfo = getProcureInfo(course?.purchased_info);
        course.priceInfo = priceInfo;
      }
      let productPrice = "";
      if (course?.product_price) {
        productPrice = `Price: $${course?.product_price}`;
      }
      // course_data.isLoggedIn = isLoggedIn;
      console.log("type-2", typeof prodArr);
      prodArr.push({
        id: course?.product_id,
        is_like: course?.is_like ? course?.is_like : false,
        is_bookmark: course?.is_bookmark ? course?.is_bookmark : false,
        dbId: course?.list_id,
        productType: "course",
        productOrigin: course?.source,
        title: course?.name,
        logoURL: course?.provider?.provider_img
          ? course?.provider?.provider_img
          : "",
        bannerURL:
          course?.product_type === "roleplay"
            ? course?.thumbnail
            : course?.imageURL,
        tagsArray: tags,
        description: course?.short_description,
        btnTitle: btnTitle,
        progress: course?.crs_progress,
        showLikeMenu: true,
        btnAction: () =>
          redirectToPageUtil(
            course,
            navigate,
            authBroker,
            setCourseData,
            dispatch
          ),
        descAction: {},
        bannerAction: () =>
          redirectToPageUtil(
            course,
            navigate,
            authBroker,
            setCourseData,
            dispatch
          ),
        footerLineComp: productPrice
          ? ProductCardPriceInfo(productPrice, "green")
          : "",
        // footerLineComp: !_.isEmpty(priceInfo)
        //   ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
        //   : "",
        showHeader: true,
        showProviderIcon: true,
        showBody: course?.short_description ? true : false,
        showFooter: true,
        showProgress: _.toNumber(course?.crs_progress) > 0 ? true : false,
        cardClassName: "",
        rightBtnIcon: "/images/arrow-right.svg",
        lefttBtnIcon: "",
        isLoading: false,
      });
    }

    return prodArr;
  };

  const assignCourse = useSelector((state) => state.courses.assignCourse);
  useEffect(() => {
    if (assignCourse?.status === "success" && !_.isEmpty(courseData)) {
      dispatch(getAssignCourseClear());
      goToModuleDetail(courseData);
    }
  }, [assignCourse, courseData]);

  const goToModuleDetail = (courseData) => {
    let paramsReq = {
      source: courseData?.source,
      cid: courseData.id ? courseData.id : courseData?.wc_post_id,
      is_paid: "true",
    };
    if (courseData.course_categoryId) {
      paramsReq.catId = courseData.course_categoryId;
      paramsReq.via_cat = "true";
    } else if (courseData.isLevel) {
      paramsReq.lp_id = courseData.lp_id;
      paramsReq.is_level = "true";
      paramsReq.level_id = courseData.level_id;
    } else if (courseData.lp_id) {
      paramsReq.lp_id = courseData.lp_id;
      paramsReq.via_lp = "true";
    }

    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    let url = `/moduleDetail/${courseData?.crscd}/?c=${encodedUrl}`;
    sessionStorage.setItem("moduleForTour", url);
    navigate(url);
  };

  const formatVideoDataForProductCard = (videoList) => {
    let videoArr = [];
    console.log("videos--", videoList);
    // let video = videoList[0];
    for (let video of videoList) {
      let tags = [];
      let logoURL = "";
      let btnTitle = "Explore";
      if (!_.isEmpty(video?.provider)) {
        tags.push(video.provider.display_name);
        logoURL = video.provider.provider_img;
      }
      tags.push("Video");
      tags.push(`${video?.views} View${video?.views > 1 ? "s" : ""}`);
      if (video?.duration) {
        const duration = convertTimeFormat(video.duration, true);
        tags.push(`${duration}`);
      }

      let priceInfo = "";
      if (video?.purchased_info) {
        priceInfo = getProcureInfo(video?.purchased_info);
        video.priceInfo = priceInfo;
      }
      let productPrice = "";
      if (video?.product_price) {
        productPrice = `Price: $${video?.product_price}`;
      }
      videoArr.push({
        id: video?.product_id,
        is_like: video?.is_like ? video?.is_like : false,
        is_bookmark: video?.is_bookmark ? video?.is_bookmark : false,
        dbId: video?.list_id,
        productType: "video",
        productOrigin: video?.origin,
        title: video?.name,
        logoURL: logoURL,
        logoAltText: "VD",
        bannerURL: video?.product_thumbnail,
        tagsArray: tags,
        description: video?.description,
        duration: convertTimeFormat(video?.duration, true),
        showHeader: true,
        showProviderIcon: true,
        showLikeMenu: true,
        showPlayButton: true,
        showProgress: false,
        showBody: false,
        showFooter: true,
        btnTitle: btnTitle,
        btnAction: () => navigateToView(video),
        descAction: () => {},
        bannerAction: () => navigateToView(video),
        cardClassName: "",
        footerLineComp: productPrice
          ? ProductCardPriceInfo(productPrice, "green")
          : "",
        // footerLineComp: !_.isEmpty(priceInfo)
        //   ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
        //   : "",
        isLoading: false,
        view: video?.views,
        priceInfo: priceInfo,
        rightBtnIcon: "/images/arrow-right.svg",
        leftBtnIcon: "",
        progress: video?.progress,
        updatedAt: video?.created_dt,
      });
    }
    console.log("video Arr", videoArr);
    return videoArr;
  };

  const formatCartData = (arrList) => {
    let prodArr = [];
    if (!_.isEmpty(arrList)) {
      for (let course of arrList) {
        let tags = [];
        let btnTitle = "Explore";
        if (course?.provider?.provider_display_name) {
          tags.push(course?.provider?.provider_display_name);
        }
        if (course?.product_type === "learningpath") {
          tags.push("Learning Path");
        }
        if (
          course.product_type === "bundle" ||
          course.product_type === "learningpath"
        ) {
          if (course?.course_count > 0)
            tags.push(
              `${course.course_count} Course${
                course.course_count > 1 ? "s" : ""
              }`
            );
          if (course?.video_count > 0)
            tags.push(
              `${course.video_count} Video${course.video_count > 1 ? "s" : ""}`
            );
          if (course?.event_count > 0)
            tags.push(
              `${course.event_count} Event${course.event_count > 1 ? "s" : ""}`
            );
          if (course?.learningpath_count > 0)
            tags.push(
              `${course.learningpath_count} Learning Path${
                course.learningpath_count > 1 ? "s" : ""
              }`
            );
          if (course?.duration) {
            const duration = convertTimeFormat(Number(course.duration), true);
            tags.push(`${duration}`);
          }
        } else if (course.product_type === "video") {
          tags.push("Video");
          tags.push(`${course?.views} View${course?.views > 1 ? "s" : ""}`);
          if (Number(course?.duration)) {
            const duration = convertTimeFormat(Number(course.duration), true);
            tags.push(`${duration}`);
          }
        } else {
          tags.push("Course");
          if (course?.lessons) {
            tags.push(
              `${course.lessons} Module${course.lessons > 1 ? "s" : ""}`
            );
          }
        }
        // if (course?.duration) {
        //   const duration = convertTimeFormat(Number(course.duration), true);
        //   tags.push(duration);
        // }

        if (
          (course?.source === "ecom" || course?.source === "xsel") &&
          !course?.is_paid
        ) {
          btnTitle = "Explore";
        }
        let priceInfo = "";
        if (course?.purchased_info) {
          priceInfo = getProcureInfo(course?.purchased_info);
          course.priceInfo = priceInfo;
        }
        // course.isLoggedIn = isLoggedIn;
        let productPrice = "";
        if (course?.product_price) {
          productPrice = `Price: $${course?.product_price}`;
        }
        prodArr.push({
          id: course?.id,
          is_like: course?.is_like ? course?.is_like : false,
          is_bookmark: course?.is_bookmark ? course?.is_bookmark : false,
          dbId: course?.list_id,
          productType: "course",
          productOrigin: course?.origin,
          title: course.name,
          logoURL: course.provider?.provider_img
            ? course.provider?.provider_img
            : "",
          bannerURL: course?.thumbnail,
          tagsArray: tags,
          description: course.short_description,
          btnTitle: btnTitle,
          progress: course.crs_progress,
          // isLoggedIn: isLoggedIn,
          btnAction: () =>
            redirectToPageUtil(
              course,
              navigate,
              authBroker,
              setCourseData,
              dispatch
            ),
          descAction: {},
          bannerAction: () =>
            redirectToPageUtil(
              course,
              navigate,
              authBroker,
              setCourseData,
              dispatch
            ),
          footerLineComp: productPrice
            ? ProductCardPriceInfo(productPrice, "green")
            : "",
          // footerLineComp: !_.isEmpty(priceInfo)
          //   ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
          //   : "",
          showHeader: true,
          showProviderIcon: true,
          showLikeMenu: true,
          showBody: course.short_description ? true : false,
          showFooter: true,
          showProgress: _.toNumber(course.crs_progress) > 0 ? true : false,
          cardClassName: "",
          rightBtnIcon: "/images/arrow-right.svg",
          leftBtnIcon: "",
          updatedAt: course?.created_dt,
          priceInfo,
          isBundle: course?.product_type === "bundle",
          bundles: course?.bundles,
        });
      }
    }
    return prodArr;
  };

  const renderShimmer = () => {
    return (
      <>
        <div className="order-total_wrapper">
          <div className="carousel-content row">
            {CONFIG.INITIAL_PRODUCT_CARD_DATA_FOR_ORDERS.map((item, index) => {
              return (
                <ProductCardComponent
                  {...item}
                  key={`course-${index + 1}`}
                  lastKey={
                    CONFIG.INITIAL_PRODUCT_CARD_DATA_FOR_ORDERS.length ===
                    index + 1
                  }
                />
              );
            })}

            <div className="col-lg-8 col-md order-info-b2c">
              <div className="purchased-by">
                <ShimmerScreen case={"rect"} height="2rem" width="50%" />
              </div>
              <div className="purchaded-buy-info">
                <ShimmerScreen case={"rect"} height="2rem" width="50%" />
              </div>
              <div className="billing-detail-onrder">
                <div className="billing-info-order">
                  <h6>
                    <ShimmerScreen case={"rect"} height="2rem" width="40%" />
                  </h6>
                  <address>
                    <ShimmerScreen case={"rect"} height="2rem" width="50%" />
                    <br />
                    <ShimmerScreen case={"rect"} height="2rem" width="50%" />
                    <br />
                    <ShimmerScreen case={"rect"} height="2rem" width="50%" />
                    <br />
                    <ShimmerScreen case={"rect"} height="2rem" width="50%" />
                  </address>
                </div>
                <div className="prdouct-order-info">
                  <h6>
                    <ShimmerScreen case={"rect"} height="2rem" width="40%" />
                  </h6>
                  <address>
                    <ShimmerScreen case={"rect"} height="2rem" width="50%" />
                    <br />
                    <ShimmerScreen case={"rect"} height="2rem" width="50%" />
                    <br />
                    <ShimmerScreen case={"rect"} height="2rem" width="50%" />
                    <br />
                    <ShimmerScreen case={"rect"} height="2rem" width="50%" />
                  </address>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const dateFormat = (date) => {
    let dateObj = new Date(date);

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    let year = dateObj.getFullYear();
    let month = dateObj.getMonth();
    let day = dateObj.getDate();

    let formattedDate = months[month] + " " + day + ", " + year;
    return formattedDate;
  };

  const [filterYears, setFilterYears] = useState([]);

  useEffect(() => {
    let tempArr = [];
    for (let index = 2022; index <= new Date().getFullYear(); index++) {
      tempArr.push(index.toString());
    }
    setFilterYears(tempArr);
  }, []);

  const [selectedYear, setselectedYear] = useState(
    new Date().getFullYear().toString()
  );

  const [sorted, setSorted] = useState(false);

  const downloadPDF = async (pdfUrl, id) => {
    try {
      const response = await fetch(pdfUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      const fileURL = new URL(pdfUrl);
      const filename = fileURL.pathname.split("/").pop();

      link.setAttribute("download", filename); // Specify the name for the downloaded file
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link); // Clean up the DOM
    } catch (error) {
      console.error("Failed to download PDF:", error);
    }
  };

  return (
    <>
      <Loader start={isLoading} />
      <section className="my_order">
        <div className="order-wrapper">
          <div className="container">
            <div className="row">
              <div className="heading-section-order">
                <h3>My Orders</h3>
                {!isLoading && totalCount > 0 && !allListEmpty && (
                  <p className="subtext-order">
                    You have {totalCount} purchased item(s)
                  </p>
                )}
              </div>

              <div className="row orders">
                <div className="d-flex order-column">
                  <div className="col-md-5 search__input">
                    <div className="search-section-listing">
                      <div className="confirm-row">
                        <input
                          type="search"
                          className="form-control"
                          id="inputPassword2"
                          placeholder="Search for order..."
                          value={searchText}
                          onChange={(evt) => {
                            console.log("searchData: ", evt.target.value);
                            if (_.isEmpty(evt.target.value)) {
                              // setOrderDataArray([]);
                              // setsearchedOrNot(true);
                              setSearchText("");
                              makeSearch(true);
                            } else {
                              setSearchText(evt.target.value);
                            }
                          }}
                          disabled={isLoading}
                        />
                        <button
                          className="confirm-btn"
                          onClick={() => {
                            setselectedYear(
                              new Date().getFullYear().toString()
                            );
                            // setOrderDataArray([]);
                            // setsearchedOrNot(true);
                            makeSearch();
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M9.16667 1.66669C5.02454 1.66669 1.66667 5.02455 1.66667 9.16669C1.66667 13.3088 5.02454 16.6667 9.16667 16.6667C10.9375 16.6667 12.565 16.053 13.8481 15.0266L16.9107 18.0893C17.2362 18.4147 17.7638 18.4147 18.0893 18.0893C18.4147 17.7638 18.4147 17.2362 18.0893 16.9108L15.0266 13.8481C16.0529 12.565 16.6667 10.9375 16.6667 9.16669C16.6667 5.02455 13.3088 1.66669 9.16667 1.66669ZM3.33334 9.16669C3.33334 5.94503 5.94501 3.33335 9.16667 3.33335C12.3883 3.33335 15 5.94503 15 9.16669C15 12.3883 12.3883 15 9.16667 15C5.94501 15 3.33334 12.3883 3.33334 9.16669Z"
                              fill="black"
                            ></path>
                          </svg>
                          Search
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="select-date">
                    {totalCount > 0 && false && (
                      <p>
                        {totalCount} <span>order(s) in</span>{" "}
                      </p>
                    )}
                    <div className="input-lear position-relative d-flex">
                      <select
                        className="form-select input_searchfield order-select"
                        aria-label="Default select example"
                        onChange={(evt) => {
                          setSorted(true);
                          // setOrderDataArray([]);
                          setSearchText("");
                          setselectedYear(evt.target.value);
                          filterWithYear(evt.target.value);
                        }}
                        value={selectedYear}
                      >
                        {filterYears?.map((item, index) => {
                          return (
                            <option
                              selected={
                                item === new Date().getFullYear().toString()
                              }
                              value={item}
                            >
                              {item}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              {isLoading && false ? (
                renderShimmer()
              ) : // !isLoading &&
              orderDataArray.length > 0 ? (
                orderDataArray.map((order, index1) => {
                  return (
                    <>
                      {order?.noProduct ? (
                        ""
                      ) : (
                        <div className="col-md-12 cart-content mb-4">
                          <div className="order-total_wrapper">
                            <div className="d-flex invoice-download justify-content-end mb-3">
                              {order?.invoice_url ? (
                                <button
                                  type="button"
                                  className="startcourse-btn cursor-pointer"
                                  onClick={() =>
                                    // order?.invoice_url
                                    //   ? window.open(
                                    //       order?.invoice_url,
                                    //       "_blank"
                                    //     )
                                    //   : ""
                                    downloadPDF(
                                      order?.invoice_url,
                                      order?.orderId
                                    )
                                  }
                                >
                                  Invoice{" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="#6941C6"
                                  >
                                    <path d="M13 12H16L12 16L8 12H11V8H13V12ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"></path>
                                  </svg>
                                </button>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="carousel-content row">
                              {!_.isEmpty(order?.cardData) &&
                                order?.cardData.map((item, index) => {
                                  return (
                                    <>
                                      <ProductCardComponent
                                        {...item}
                                        key={`course-${index + 1}`}
                                        lastKey={
                                          orderDataArray?.length === index1 + 1
                                        }
                                        refInfo={paginateCB}
                                      />

                                      <div className="col-lg-8 col-md order-info-b2c">
                                        {/* <div className="d-flex justify-content-end mb-2 btn-wrap-order">
                                  <button className="purchase-again d-flex align-items-center justify-content-center">
                                    Purchase again
                                  </button>
                                </div> */}
                                        <div className="purchased-by">
                                          Purchased by
                                        </div>
                                        <div className="purchaded-buy-info">
                                          You ({order?.billing_first_name}) -{" "}
                                          {order?.billing_email}
                                        </div>
                                        <div className="billing-detail-onrder">
                                          <div className="billing-info-order">
                                            <h6>Billing details</h6>
                                            <address>
                                              {order?.billing_first_name}
                                              <br />
                                              {order?.billing_address_1}{" "}
                                              {order?.billing_city}
                                              <br />
                                              {order?.billing_country}
                                              <br />
                                              {order?.billing_phone}
                                            </address>
                                          </div>
                                          <div className="prdouct-order-info">
                                            <h6>Order details</h6>
                                            <address>
                                              Payment method:{" "}
                                              {_.toUpper(
                                                order?.card_details?.card_brand
                                              )}{" "}
                                              Credit Card ending in{" "}
                                              {order?.card_details?.card_last4}
                                              <br />
                                              Order ID: XSEL-{order?.orderId}
                                              <br />
                                              Date of purchase:{" "}
                                              {dateFormat(
                                                order?.order_completed?.date
                                              )}
                                              <br />
                                              Transaction ID:{" "}
                                              {order?.order_code}
                                            </address>
                                          </div>
                                        </div>
                                      </div>
                                      {order?.cardData?.length === index + 1 ? (
                                        <>
                                          <div class="sep"></div>
                                          <div className="order-total d-flex justify-content-between align-items-center gap-2">
                                            <div className="totl-heading">
                                              Total
                                              <span className="taxes">
                                                Incl. of taxes (CA $
                                                {order?.stripe_tax})
                                              </span>
                                            </div>
                                            <div className="price-box">
                                              CA ${order?.total}
                                            </div>
                                          </div>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      {order?.cardData?.length !== index + 1 ? (
                                        <div className="sep"></div>
                                      ) : (
                                        ""
                                      )}
                                    </>
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })
              ) : (
                <NotFoundComponent showMsg={true} msgLine={"No Orders Found"} />
              )}

              {/* <PaginationMyOrders
                className="pagination-bar "
                currentPage={currentPage}
                totalCount={orderDataArray.length}
                pageSize={PageSize}
                onPageChange={(page) => setCurrentPage(page)}
              /> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default OrderHistorySectionCopy;
